export function formatColumnSummary(name, info) {
  const details = [
    info.type,
    info.missingCount
      ? `${info.missingCount} blank${info.missingCount === 1 ? '' : 's'}`
      : 'no blanks',
    `${info.uniqueValues} unique`,
  ]

  if (info.likelyId) details.push('looks like an ID')
  if (info.likelyMeasure) details.push('works as a numeric measure')
  if (info.tooManyUniques) details.push('may be too detailed for categories')
  if (info.outlierCount) {
    details.push(
      `${info.outlierCount} unusual value${info.outlierCount === 1 ? '' : 's'}`
    )
  }

  return `${name}: ${details.join(' · ')}`
}

export function getTextColorChoices(palette = []) {
  const baseChoices = [
    { name: 'Black', hex: '#181818' },
    { name: 'White', hex: '#ffffff' },
  ]
  const paletteChoices = (palette || []).slice(0, 4)
  const seen = new Set()

  return [...baseChoices, ...paletteChoices].filter((color) => {
    const key = color.hex?.toLowerCase()
    if (!key || seen.has(key)) return false
    seen.add(key)
    return true
  })
}
